/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { GrantListResponse } from '../models/grant-list-response';
import { identityControllerActivateUser } from '../fn/identity/identity-controller-activate-user';
import { IdentityControllerActivateUser$Params } from '../fn/identity/identity-controller-activate-user';
import { identityControllerAssignRole } from '../fn/identity/identity-controller-assign-role';
import { IdentityControllerAssignRole$Params } from '../fn/identity/identity-controller-assign-role';
import { identityControllerChangePassword } from '../fn/identity/identity-controller-change-password';
import { IdentityControllerChangePassword$Params } from '../fn/identity/identity-controller-change-password';
import { identityControllerCreate } from '../fn/identity/identity-controller-create';
import { IdentityControllerCreate$Params } from '../fn/identity/identity-controller-create';
import { identityControllerDelete } from '../fn/identity/identity-controller-delete';
import { IdentityControllerDelete$Params } from '../fn/identity/identity-controller-delete';
import { identityControllerDeleteImage } from '../fn/identity/identity-controller-delete-image';
import { IdentityControllerDeleteImage$Params } from '../fn/identity/identity-controller-delete-image';
import { identityControllerForgotPassword } from '../fn/identity/identity-controller-forgot-password';
import { IdentityControllerForgotPassword$Params } from '../fn/identity/identity-controller-forgot-password';
import { identityControllerGetAll } from '../fn/identity/identity-controller-get-all';
import { IdentityControllerGetAll$Params } from '../fn/identity/identity-controller-get-all';
import { identityControllerGetAllTourLeaders } from '../fn/identity/identity-controller-get-all-tour-leaders';
import { IdentityControllerGetAllTourLeaders$Params } from '../fn/identity/identity-controller-get-all-tour-leaders';
import { identityControllerGetGrants } from '../fn/identity/identity-controller-get-grants';
import { IdentityControllerGetGrants$Params } from '../fn/identity/identity-controller-get-grants';
import { identityControllerGetMyself } from '../fn/identity/identity-controller-get-myself';
import { IdentityControllerGetMyself$Params } from '../fn/identity/identity-controller-get-myself';
import { identityControllerGetMyselfStats } from '../fn/identity/identity-controller-get-myself-stats';
import { IdentityControllerGetMyselfStats$Params } from '../fn/identity/identity-controller-get-myself-stats';
import { identityControllerGetOne } from '../fn/identity/identity-controller-get-one';
import { IdentityControllerGetOne$Params } from '../fn/identity/identity-controller-get-one';
import { identityControllerGetOneByUsername } from '../fn/identity/identity-controller-get-one-by-username';
import { IdentityControllerGetOneByUsername$Params } from '../fn/identity/identity-controller-get-one-by-username';
import { identityControllerGetUsersStats } from '../fn/identity/identity-controller-get-users-stats';
import { IdentityControllerGetUsersStats$Params } from '../fn/identity/identity-controller-get-users-stats';
import { identityControllerLoginPassport } from '../fn/identity/identity-controller-login-passport';
import { IdentityControllerLoginPassport$Params } from '../fn/identity/identity-controller-login-passport';
import { identityControllerProfilePicture } from '../fn/identity/identity-controller-profile-picture';
import { IdentityControllerProfilePicture$Params } from '../fn/identity/identity-controller-profile-picture';
import { identityControllerRegister } from '../fn/identity/identity-controller-register';
import { IdentityControllerRegister$Params } from '../fn/identity/identity-controller-register';
import { identityControllerResetPassword } from '../fn/identity/identity-controller-reset-password';
import { IdentityControllerResetPassword$Params } from '../fn/identity/identity-controller-reset-password';
import { identityControllerResetRegistry } from '../fn/identity/identity-controller-reset-registry';
import { IdentityControllerResetRegistry$Params } from '../fn/identity/identity-controller-reset-registry';
import { identityControllerUpdate } from '../fn/identity/identity-controller-update';
import { IdentityControllerUpdate$Params } from '../fn/identity/identity-controller-update';
import { identityControllerUserHasGrants } from '../fn/identity/identity-controller-user-has-grants';
import { IdentityControllerUserHasGrants$Params } from '../fn/identity/identity-controller-user-has-grants';
import { LoginResponse } from '../models/login-response';
import { MediaItem } from '../models/media-item';
import { OptionalRefreshTokenResponse } from '../models/optional-refresh-token-response';
import { UserItem } from '../models/user-item';
import { UserResponse } from '../models/user-response';
import { UsersStatsResponse } from '../models/users-stats-response';
import { UserTourLeaderStats } from '../models/user-tour-leader-stats';

@Injectable({ providedIn: 'root' })
export class IdentityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `identityControllerGetGrants()` */
  static readonly IdentityControllerGetGrantsPath = '/identity/grants';

  /**
   * Recupera tutti i grant dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetGrants$Response(params?: IdentityControllerGetGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantListResponse;
}>> {
    return identityControllerGetGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera tutti i grant dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetGrants(params?: IdentityControllerGetGrants$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantListResponse;
}> {
    return this.identityControllerGetGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantListResponse;
}>): BaseResponse & {
'data'?: GrantListResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetAll()` */
  static readonly IdentityControllerGetAllPath = '/identity';

  /**
   * Restituisce l'elenco degli utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAll$Response(params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
    return identityControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAll(params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserResponse;
}> {
    return this.identityControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>): BaseResponse & {
'data'?: UserResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerCreate()` */
  static readonly IdentityControllerCreatePath = '/identity';

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerCreate$Response(params: IdentityControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerCreate(params: IdentityControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerRegister()` */
  static readonly IdentityControllerRegisterPath = '/identity/register';

  /**
   * Registra un utente con email e password (frontend).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerRegister$Response(params: IdentityControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * Registra un utente con email e password (frontend).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerRegister(params: IdentityControllerRegister$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerActivateUser()` */
  static readonly IdentityControllerActivateUserPath = '/identity/activate/{code}';

  /**
   * Attiva un utente dal suo codice di attivazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerActivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerActivateUser$Response(params: IdentityControllerActivateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerActivateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Attiva un utente dal suo codice di attivazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerActivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerActivateUser(params: IdentityControllerActivateUser$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerActivateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerAssignRole()` */
  static readonly IdentityControllerAssignRolePath = '/identity/role';

  /**
   * Permette di assegnare un ruolo a uno o più utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerAssignRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRole$Response(params: IdentityControllerAssignRole$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OptionalRefreshTokenResponse;
}>> {
    return identityControllerAssignRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Permette di assegnare un ruolo a uno o più utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerAssignRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRole(params: IdentityControllerAssignRole$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: OptionalRefreshTokenResponse;
}> {
    return this.identityControllerAssignRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: OptionalRefreshTokenResponse;
}>): BaseResponse & {
'data'?: OptionalRefreshTokenResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerChangePassword()` */
  static readonly IdentityControllerChangePasswordPath = '/identity/changePassword';

  /**
   * Utilizzato per effettuare il cambio password dell'utente autenticato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerChangePassword$Response(params: IdentityControllerChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Utilizzato per effettuare il cambio password dell'utente autenticato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerChangePassword(params: IdentityControllerChangePassword$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerResetPassword()` */
  static readonly IdentityControllerResetPasswordPath = '/identity/forgotPassword/reset';

  /**
   * Utilizzato per effettuare il reset della password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerResetPassword$Response(params: IdentityControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Utilizzato per effettuare il reset della password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerResetPassword(params: IdentityControllerResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerForgotPassword()` */
  static readonly IdentityControllerForgotPasswordPath = '/identity/forgotPassword';

  /**
   * Utilizzato per effettuare il recupero della password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerForgotPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerForgotPassword$Response(params: IdentityControllerForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerForgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Utilizzato per effettuare il recupero della password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerForgotPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerForgotPassword(params: IdentityControllerForgotPassword$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerForgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerGetOne()` */
  static readonly IdentityControllerGetOnePath = '/identity/{id}';

  /**
   * Restituisce un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOne$Response(params: IdentityControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOne(params: IdentityControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerDelete()` */
  static readonly IdentityControllerDeletePath = '/identity/{id}';

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDelete$Response(params: IdentityControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDelete(params: IdentityControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerUpdate()` */
  static readonly IdentityControllerUpdatePath = '/identity/{id}';

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdate$Response(params: IdentityControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdate(params: IdentityControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerResetRegistry()` */
  static readonly IdentityControllerResetRegistryPath = '/identity/{id}/registry';

  /**
   * Rimuove le informazioni fiscali da un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerResetRegistry()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerResetRegistry$Response(params: IdentityControllerResetRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerResetRegistry(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove le informazioni fiscali da un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerResetRegistry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerResetRegistry(params: IdentityControllerResetRegistry$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerResetRegistry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerProfilePicture()` */
  static readonly IdentityControllerProfilePicturePath = '/identity/{id}/picture';

  /**
   * Foto profilo per utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerProfilePicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  identityControllerProfilePicture$Response(params: IdentityControllerProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerProfilePicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto profilo per utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerProfilePicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  identityControllerProfilePicture(params: IdentityControllerProfilePicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerProfilePicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerDeleteImage()` */
  static readonly IdentityControllerDeleteImagePath = '/identity/{id}/picture';

  /**
   * Elimina l'immagine dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDeleteImage$Response(params: IdentityControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>> {
    return identityControllerDeleteImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina l'immagine dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDeleteImage(params: IdentityControllerDeleteImage$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaItem;
}> {
    return this.identityControllerDeleteImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>): BaseResponse & {
'data'?: MediaItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetAllTourLeaders()` */
  static readonly IdentityControllerGetAllTourLeadersPath = '/identity/tour-leaders';

  /**
   * Restituisce l'elenco dei tour leaders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetAllTourLeaders()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAllTourLeaders$Response(params: IdentityControllerGetAllTourLeaders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
    return identityControllerGetAllTourLeaders(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei tour leaders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetAllTourLeaders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAllTourLeaders(params: IdentityControllerGetAllTourLeaders$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserResponse;
}> {
    return this.identityControllerGetAllTourLeaders$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>): BaseResponse & {
'data'?: UserResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetMyself()` */
  static readonly IdentityControllerGetMyselfPath = '/identity/myself';

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetMyself()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyself$Response(params?: IdentityControllerGetMyself$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerGetMyself(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetMyself$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyself(params?: IdentityControllerGetMyself$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerGetMyself$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetMyselfStats()` */
  static readonly IdentityControllerGetMyselfStatsPath = '/identity/myself/stats';

  /**
   * Restituisce le statistiche del Tour Leader.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetMyselfStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyselfStats$Response(params?: IdentityControllerGetMyselfStats$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserTourLeaderStats;
}>> {
    return identityControllerGetMyselfStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le statistiche del Tour Leader.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetMyselfStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyselfStats(params?: IdentityControllerGetMyselfStats$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserTourLeaderStats;
}> {
    return this.identityControllerGetMyselfStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserTourLeaderStats;
}>): BaseResponse & {
'data'?: UserTourLeaderStats;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetUsersStats()` */
  static readonly IdentityControllerGetUsersStatsPath = '/identity/users/stats';

  /**
   * Restituisce le statistiche degli utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetUsersStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetUsersStats$Response(params?: IdentityControllerGetUsersStats$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UsersStatsResponse;
}>> {
    return identityControllerGetUsersStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce le statistiche degli utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetUsersStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetUsersStats(params?: IdentityControllerGetUsersStats$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UsersStatsResponse;
}> {
    return this.identityControllerGetUsersStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UsersStatsResponse;
}>): BaseResponse & {
'data'?: UsersStatsResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetOneByUsername()` */
  static readonly IdentityControllerGetOneByUsernamePath = '/identity/username/{username}';

  /**
   * Restituisce un utente dallo username.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetOneByUsername()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOneByUsername$Response(params: IdentityControllerGetOneByUsername$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerGetOneByUsername(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un utente dallo username.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetOneByUsername$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOneByUsername(params: IdentityControllerGetOneByUsername$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerGetOneByUsername$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerLoginPassport()` */
  static readonly IdentityControllerLoginPassportPath = '/identity/session';

  /**
   * Login.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerLoginPassport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerLoginPassport$Response(params: IdentityControllerLoginPassport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>> {
    return identityControllerLoginPassport(this.http, this.rootUrl, params, context);
  }

  /**
   * Login.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerLoginPassport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerLoginPassport(params: IdentityControllerLoginPassport$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: LoginResponse;
}> {
    return this.identityControllerLoginPassport$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>): BaseResponse & {
'data'?: LoginResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerUserHasGrants()` */
  static readonly IdentityControllerUserHasGrantsPath = '/identity/userHasGrants';

  /**
   * Verifica che l'utente del JWT abbia i grant richiesti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerUserHasGrants()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUserHasGrants$Response(params: IdentityControllerUserHasGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerUserHasGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Verifica che l'utente del JWT abbia i grant richiesti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerUserHasGrants$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUserHasGrants(params: IdentityControllerUserHasGrants$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerUserHasGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
